export default function StrengthsSection() {
  const strengths = [
    {
      number: "01",
      title: "豊富な実績と高い技術力",
      description: "農業ドローン協議会認定の操縦士が対応。教習所運営で培った確かな技術で、安全かつ正確な散布を実現します。",
      icon: "ri-award-line",
      image: "https://public.readdy.ai/ai/img_res/4704a349d48497f1e40c78569456a2cc.jpg"
    },
    {
      number: "02", 
      title: "柔軟な対応力",
      description: "水稲、麦、大豆、野菜、果樹まで幅広く対応。農薬のご用意も可能です。多量散布や特殊な圃場条件も、まずはご相談ください。",
      icon: "ri-plant-line",
      image: "https://readdy.ai/api/search-image?query=Diverse%20agricultural%20crops%20including%20rice%2C%20wheat%2C%20soybeans%2C%20vegetables%20and%20fruit%20trees%2C%20variety%20of%20farming%20applications%2C%20flexible%20agricultural%20solutions%2C%20multiple%20crop%20types%20in%20organized%20farming%20layout%2C%20comprehensive%20agricultural%20services&width=600&height=400&seq=strength-02&orientation=landscape"
    },
    {
      number: "03",
      title: "広域カバー・地域密着のサポート", 
      description: "佐賀県全域、福岡県筑後地区、鹿児島県に拠点を構え、広範囲をカバー。中山間地域の複雑な圃場にも対応。地域に根差したサービスを提供し、急なご依頼にも迅速に対応いたします。",
      icon: "ri-map-pin-line",
      image: "https://readdy.ai/api/search-image?query=Wide%20coverage%20area%20map%20showing%20Saga%2C%20Fukuoka%20Chikugo%20region%20and%20Kagoshima%20prefectures%2C%20regional%20service%20network%2C%20mountainous%20agricultural%20areas%2C%20comprehensive%20geographical%20coverage%2C%20local%20community%20support%20services&width=600&height=400&seq=strength-03&orientation=landscape"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            IDS教習所グループ請負サービスの
            <span className="text-[#4CAF50] block">3つの強み</span>
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto"></div>
        </div>

        <div className="space-y-16">
          {strengths.map((strength, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="flex-1">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-[#4CAF50] text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${strength.icon} text-2xl`}></i>
                  </div>
                  <div>
                    <span className="text-[#4CAF50] font-bold text-lg">STRENGTH {strength.number}</span>
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-900">{strength.title}</h3>
                  </div>
                </div>
                <p className="text-lg text-gray-700 leading-relaxed">{strength.description}</p>
              </div>
              <div className="flex-1">
                <img 
                  src={strength.image}
                  alt={strength.title}
                  className="w-full h-80 object-cover rounded-2xl shadow-lg"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}